<div class="p-4">
  <div class="p-fluid">
    <div class="field">
      <div class="ui-widget field-label">
        <label>Thank you for your submission.</label>
      </div>
    </div>
  </div>
</div>
